module.exports = __webpack_public_path__ + "img/16.b3e4b8cd.png";